<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>

    <v-card color="grey lighten-5" flat>
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <v-flex xs12 sm12 md12>
            <v-card color="grey lighten-5" flat>
              <v-card-text>
                <v-flex xs12 sm12 md12 mt-1>
                  <v-hover>
                    <v-card
                      slot-scope="{ hover }"
                      :class="`elevation-${hover ? 12 : 2}`"
                      class="elevation-1 pa-3"
                    >
                      <v-layout row wrap align-center pl-1>
                        <v-flex xs12 sm1 md1>
                          <strong>
                            {{ getSaticiTip(tip, SaticiTip) }}
                          </strong>
                        </v-flex>

                        <v-flex xs12 sm6 md3>
                          <v-layout row wrap>
                            <v-list>
                              <v-list-tile v-if="tip == 1">
                                <genelarama
                                  apiname="SaticiAra"
                                  :tip="14"
                                  label="Satıcı Kod :"
                                  v-model="val.Satici"
                                ></genelarama>
                              </v-list-tile>
                              <v-list-tile v-else>
                                <genelarama
                                  apiname="SaticiAra"
                                  :tip="10"
                                  label="Satıcı Kod :"
                                  v-model="val.Satici"
                                ></genelarama>
                              </v-list-tile>
                            </v-list>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm5 md2>
                          <v-layout row wrap>
                            <v-list>
                              <v-list-tile>
                                <span
                                  class="subheading red--text font-weight-bold"
                                >
                                  {{$t('Sales')}} &nbsp;:</span
                                >
                                <span class="ml-3">
                                  <v-text-field
                                    :label="$t('Sales')"
                                    v-model="val.Satis"
                                  ></v-text-field>
                                </span>
                              </v-list-tile>
                              <v-list-tile>
                                <span
                                  class="subheading red--text font-weight-bold"
                                >
                                  Alış&nbsp;&nbsp;&nbsp;:</span
                                >
                                <span class="ml-3">
                                  <v-text-field
                                    :label="$t('Buying')"
                                    v-model="val.Alis"
                                  ></v-text-field>
                                </span>
                              </v-list-tile>
                            </v-list>
                          </v-layout>
                        </v-flex>
                          
                        <v-flex xs12 sm3 md1 v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm">
                          <v-layout row wrap>
                            <v-list>
                              <v-list-tile>
                                <v-text-field
                                  :label="$t('Sales-Currency')"
                                  v-model="val.SatisKur"
                                ></v-text-field>
                              </v-list-tile>
                              <v-list-tile>
                                <v-text-field
                                  label="Alış Kur"
                                  v-model="val.AlisKur"
                                ></v-text-field>
                              </v-list-tile>
                            </v-list>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          xs12
                          sm5
                          md3
                          v-show="
                            $vuetify.breakpoint.sm ||
                            $vuetify.breakpoint.md ||
                            $vuetify.breakpoint.lg ||
                            $vuetify.breakpoint.xl
                          "
                        >
                          <v-layout row wrap>
                            <v-list>
                              <v-list-tile>
                                <v-autocomplete
                                  dense
                                  autowidth
                                  height="12px"
                                  hide-details
                                  :items="doviztipi"
                                  v-model="val.SatisPara"
                                  @input="getKur('satis')"
                                  item-text="Title"
                                  item-value="DovizKod"
                                  :label="$t('Currency-Unit')"
                                ></v-autocomplete>
                              </v-list-tile>
                              <v-list-tile>
                                <v-select
                                  dense
                                  height="12px"
                                  hide-details
                                  :items="doviztipi"
                                  v-model="val.AlisPara"
                                  @input="getKur('alis')"
                                  item-text="Title"
                                  item-value="DovizKod"
                                  :label="$t('Currency-Unit')"
                                ></v-select>
                              </v-list-tile>
                            </v-list>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          xs12
                          sm3
                          md2
                          v-show="
                            $vuetify.breakpoint.md ||
                            $vuetify.breakpoint.lg ||
                            $vuetify.breakpoint.xl
                          "
                        >
                          <v-layout row wrap>
                            <v-list>
                              <v-list-tile>
                                <v-text-field
                                  :label="$t('Exchange-Rate-v2')"
                                  v-model="val.SatisKur"
                                ></v-text-field>
                              </v-list-tile>
                              <v-list-tile>
                                <v-text-field
                                  :label="$t('Exchange-Rate-v2')"
                                  v-model="val.AlisKur"
                                ></v-text-field>
                              </v-list-tile>
                            </v-list>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm3 md1>
                          <v-layout row wrap>
                            <v-list>
                              <v-list-tile>
                                <v-text-field
                                  :label="$t('VAT')"
                                  v-model="val.SatisKDV"
                                ></v-text-field>
                              </v-list-tile>
                              <v-list-tile> </v-list-tile>
                            </v-list>
                          </v-layout>
                        </v-flex>

                        <v-flex xs12 sm3 md2 v-show="$vuetify.breakpoint.xs">
                          <v-layout row wrap>
                            <v-list>
                              <v-list-tile>
                                <v-autocomplete
                                  dense
                                  height="12px"
                                  hide-details
                                  :items="doviztipi"
                                  v-model="val.SatisPara"
                                  @input="getKur('satis')"
                                  item-text="Title"
                                  item-value="DovizKod"
                                  :label="$t('Sales-Currency-Type')"
                                ></v-autocomplete>
                              </v-list-tile>
                              <v-list-tile>
                                <v-autocomplete
                                  dense
                                  height="12px"
                                  hide-details
                                  :items="doviztipi"
                                  v-model="val.AlisPara"
                                  @input="getKur('alis')"
                                  item-text="Title"
                                  item-value="DovizKod"
                                  :label="$t('Purchase-Currency-Type')"
                                ></v-autocomplete>
                              </v-list-tile>
                            </v-list>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-hover>
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-flex>
      </v-layout>
    </v-card>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import helpers from "@/components/app/customcomp/helpers.js";
import genelarama from "@/components/app/coper/comp/genelarama";
import tool from "@/components/app/coper/tools";

export default {
  props: {
    value: {},
    tip: {},
    doviztipi: {},
  },
  computed: {
    val: {
      get: function () {
        return this.value;
      },
      set: function (newValue) {
        this.$emit("input", newValue);
      },
    },
  },
  data() {
    return {
      kurList: [],
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      SaticiTip: [
        {
          Aciklama: this.$t('Insurance'),
          Kod: 1,
        },
        {
          Aciklama: this.$t('Service-v2'),
          Kod: 2,
        },
        {
          Aciklama: this.$t('Other'),
          Kod: 3,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 1",
          Kod: 4,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 2",
          Kod: 5,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 3",
          Kod: 6,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 4",
          Kod: 7,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 5",
          Kod: 8,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 6",
          Kod: 9,
        },
        {
          Aciklama: this.$t('Additional-Services') + " 7",
          Kod: 10,
        },
      ],
    };
  },
  methods: {
    getSaticiTip: function (satisTip, satisList) {
      let _resultSaticTipText = null;
      satisList.forEach((element) => {
        if (element.Kod == satisTip) {
          _resultSaticTipText = element.Aciklama;
          this.val.HizmetTip = element.Kod;
        }
      });
      return _resultSaticTipText;
    },
    getKur(val) {
      if (this.kurList.length == 0) {
        if (this.kayitTarihi == null) {
          this.kayitTarihi = tool.Now_yyyy_MM_dd();
        }

        tool
          .http_post(this, "KurAra", {
            tarih: tool.Now_yyyy_MM_dd(),
          })
          .then(
            (response) => {
              this.kurList = response.body;
              this.selectKur(val);
            },
            (response) => {
              this.text1 = "Service Unavailable-Döviz Coper";
              this.snackbar = true;
            }
          );
      } else {
        this.selectKur(val);
      }
    },
    selectKur(tip) {
      if (tip == "satis") {
        var resultSatis = this.kurList.find(this.paraAraSatis);
        if (resultSatis == undefined) {
          this.val.SatisKur = 1;
        } else {
          this.val.SatisKur = resultSatis.kur;
        }
      } else if (tip == "alis") {
        var resultAlis = this.kurList.find(this.paraAraAlis);
        if (resultAlis == undefined) {
          this.val.AlisKur = 1;
        } else {
          this.val.AlisKur = resultAlis.kur;
        }
      }
    },
    paraAraSatis(paraBirimi) {
      return paraBirimi.paraBirimi == this.val.SatisPara;
    },
    paraAraAlis(paraBirimi) {
      return paraBirimi.paraBirimi == this.val.AlisPara;
    },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    genelarama,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
  mounted() {
    // this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;
    //           window.open(url, "_self");
    //         } else {
    //           var url = "#/";
    //           window.open(url, "_self");
    //         }
    //       } else {
    //       }
    //     });
    // }
  },
};
</script>